export const arrayMove = (array, oldIndex, newIndex) => {
    const newArray = [...array];

    while (oldIndex < 0) {
        oldIndex += newArray.length;
    }

    while (newIndex < 0) {
        newIndex += newArray.length;
    }

    if (newIndex >= newArray.length) {
        let k = newIndex - newArray.length + 1;

        while (k--) {
            newArray.push(undefined);
        }
    }

    newArray.splice(newIndex, 0, newArray.splice(oldIndex, 1)[0]);

    return newArray;
};